import React, { FC } from 'react';

import { SimpleGrid } from '@mantine/core';

const TeaserGrid: FC<{
    children: React.ReactNode;
}> = ({ children }) => (
    <SimpleGrid cols={{ base: 1, sm: 2, lg: 3 }} spacing={40} verticalSpacing={80}>
        {children}
    </SimpleGrid>
);

export { TeaserGrid };
